import { render, staticRenderFns } from "./QFormAddStaff.vue?vue&type=template&id=2c6caef3&"
import script from "./QFormAddStaff.vue?vue&type=script&lang=js&"
export * from "./QFormAddStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports